export const groupTimezone = (timezones) => {
  const groupedTimezones = timezones.reduce((accTimezones, timezone) => {
    const temp = timezone.split("/");
    const region = temp[0];
    const city = temp[1];

    if (region !== "UTC") {
      if (!accTimezones[region]) {
        accTimezones[region] = {
          label: region,
          options: [],
        };
      }
      accTimezones[region].options.push({
        label: city,
        value: timezone,
      });
    }
    return accTimezones;
  }, {});

  return Object.values(groupedTimezones);
};
